import { useId, type ReactNode } from 'react';
import './TooltipWrapper.css';

interface TooltipWrapperProps {
  children: ReactNode;
  content: string;
}

export function TooltipWrapper({ children, content }: TooltipWrapperProps) {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '');

  if (!content) {
    return <>{children}</>;
  }

  return (
    <span className="tooltip-wrapper">
      <span
        className="tooltip-trigger"
        style={{ anchorName: `--tt-${uid}` } as React.CSSProperties}
      >
        {children}
      </span>
      <span
        className="tooltip-text"
        style={{ positionAnchor: `--tt-${uid}` } as React.CSSProperties}
      >
        {content}
      </span>
    </span>
  );
}
